var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQ(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C3.11818 0 0 3.11818 0 7C0 10.8818 3.11818 14 7 14C10.8818 14 14 10.8818 14 7C14 3.11818 10.8818 0 7 0ZM7 12.0909C4.2 12.0909 1.90909 9.8 1.90909 7C1.90909 4.2 4.2 1.90909 7 1.90909C9.8 1.90909 12.0909 4.2 12.0909 7C12.0909 9.8 9.8 12.0909 7 12.0909ZM6.04545 6.36364V10.8182H7.95455V6.36364H6.04545ZM8.27273 4.45455C8.27273 5.15773 7.7 5.72727 7 5.72727C6.3 5.72727 5.72727 5.15773 5.72727 4.45455C5.72727 3.75136 6.3 3.18182 7 3.18182C7.7 3.18182 8.27273 3.75136 8.27273 4.45455Z",
    fill: "#757575"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQ);
export default __webpack_public_path__ + "static/media/icon-q.e90f28f9eea6ba17a504efdeb2a97688.svg";
export { ForwardRef as ReactComponent };